var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareGabi1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "28 24.5 38.8 39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .ink{stroke:#171514; fill:none; stroke-width:3.2; stroke-linecap:round; stroke-linejoin:round;}\n    .nodeStroke{stroke:#171514; fill:none; stroke-width:2.4;}\n    .c1{fill:#64B0C4;}\n    .c2{fill:#FEC33E;}\n    .c3{fill:#F5886B;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,43 L54.8,34.5 M40.5,45 L54.8,53.5",
    className: "ink"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 6.3,
    className: "c1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.8,
    cy: 32.5,
    r: 6.3,
    className: "c2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.8,
    cy: 55.5,
    r: 6.3,
    className: "c3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 6.3,
    className: "nodeStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.8,
    cy: 32.5,
    r: 6.3,
    className: "nodeStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.8,
    cy: 55.5,
    r: 6.3,
    className: "nodeStroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGabi1);
export default __webpack_public_path__ + "static/media/SHARE_GABI1.759302a3b7b7723a2bb7b0f260a6387f.svg";
export { ForwardRef as ReactComponent };